export default "__VITE_ASSET__CTsoLB2J__"